function initMainCatalog() {
	const mainCatalog = document.querySelector('.main-catalog')
	if (!mainCatalog) return
	const catalog = mainCatalog.querySelector('.catalog-header')
	const mediaRequest = window.matchMedia('(max-width: 1250px)')

	if (mediaRequest.matches) {
		const blockNavHeader = document.querySelector('.header__block-nav-search')
		const container = document.querySelector('.container')
		const hight = blockNavHeader.offsetHeight
		const top = blockNavHeader.offsetTop
		catalog.style.width = `${window.innerWidth}px`
		catalog.style.height = `${window.innerHeight - hight + 10}px`

		function openList(event, listItem, list) {
			if (event.target.closest(listItem)) {
				const li = event.target.closest(listItem)
				const ul = li.querySelector(list)
				if (!ul) return
				ul.classList.add('active-list')
				const listMob = li.closest('ul')
				const heightList = listMob.offsetHeight
				ul.style.minHeight = `${heightList}px`
			}
		}

		mainCatalog.addEventListener('click', event => {
			if (event.target.closest('.main-catalog__button')) {
				event.target.closest('header').querySelector('.main-logo, .notice').setAttribute('style', 'opacity: 1;')

				if (catalog.classList.contains('active-mob')) {
					blockNavHeader.classList.remove('header__block-nav-search--active-mob')
					blockNavHeader.style.top = `${top}px`
					catalog.classList.remove('active-mob')
					container.classList.remove('bg-menu-mob')
				} else {
					blockNavHeader.classList.add('header__block-nav-search--active-mob')
					if (event.target.closest('header').querySelector('[scroll]')) {
						blockNavHeader.style.top = '10px'
						event.target.closest('header').querySelector('.main-logo, .notice').setAttribute('style', 'opacity: 0; pointer-events: none')
					} else {
						blockNavHeader.style.top = `-${top - hight}px`
					}
					catalog.classList.add('active-mob')
					container.classList.add('bg-menu-mob')
				}
			}

			openList(event, '.catalog-header__list-item-product', '.catalog-header__list-product-second-level')
			openList(event, '.catalog-header__list-product-second-level-item', '.catalog-header__list-product-third-level')
		})
	} else {
		document.addEventListener('click', event => {
			if (event.target.closest('.main-catalog')) {
				if (event.target.closest('.main-catalog__button')) {
					catalog.classList.toggle('active')
				}
			} else {
				catalog.classList.remove('active')
			}
		})
	}
}
